import React from "react";
import { X } from "phosphor-react";
import { TextAreaWithSuffixHelpersFloatingLabel } from "./Shared";

export function TextAreaInput({ label, value, setValue }) {
  return (
    <TextAreaWithSuffixHelpersFloatingLabel
      value={value}
      onChange={(e) => setValue(e.target.value)}
      label={label}
      id={label}
      width="100%"
      helpers={[<X weight="thin" size={14} onClick={() => setValue("")} />]}
    />
  );
}
